import {
  BooleanParam,
  DateRangeParam,
  QueryParamConfigMap,
  StringParam,
  useTrackedCustomSearchParams,
  withDefault,
} from 'common/hooks/customSearchParams';
import { SegmentEvent } from 'services/helpers/segment';
import { OutstandingFeesBreakdown } from 'services/clients/insights';

export enum HistoricalPerDiemCalendarPeriod {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
}

export const HISTORICAL_PER_DIEM_QUERY_PARAMS: QueryParamConfigMap = {
  dateRange: withDefault(DateRangeParam, {
    startDate: '-30:days',
    endDate: 'today',
  }),
  compare: BooleanParam,
  breakdown: withDefault(StringParam, OutstandingFeesBreakdown.ShippingLine),
  calendarPeriod: StringParam,
  custom: BooleanParam, // Stores whether the user has selected a custom date range
};

export const useTrackedHistoricalParams = () => {
  return useTrackedCustomSearchParams(
    SegmentEvent.ShipmentsHistoricalPerDiemSearched,
    HISTORICAL_PER_DIEM_QUERY_PARAMS
  );
};
